import ZoomAppsSdk from './ZoomSdk';

export default new ZoomAppsSdk();
